import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { useState } from 'react';

const parseError = (e) => e instanceof Error ? e : new Error(String(e));
// the tests for this hook are flaky, so we're currently skipping them in Jest
// if you're modfying this hook, make sure to run the tests manually!
const useAsync = (fn, 
// pass an element ref to avoid setting state after parent dismounts
ref) => {
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const asyncFn = () => __awaiter(void 0, void 0, void 0, function* () {
        setError(undefined);
        setLoading(true);
        try {
            yield fn();
            if (!ref || ref.current)
                setLoading(false);
        }
        catch (e) {
            setLoading(false);
            setError(parseError(e));
        }
    });
    return [{ error, loading }, asyncFn];
};

export { parseError, useAsync };
